import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {Check} from '@sparkware/app-utils';
import {IValueEvaluator} from '../../value-evaluators/value-evaluator.interface/value-evaluator.interface';
import {IStatementEvaluator} from '../statement-evaluator/statement-evaluator.interface';

export class StatementsEvaluator implements IValueEvaluator {
  constructor(private _statementsEvaluators: IStatementEvaluator[], private _defaultValue: any) {
  }

  get defaultValue() {
    return this._defaultValue;
  }

  get evaluators(): IStatementEvaluator[] {
    return this._statementsEvaluators
  }

  evaluate(context: IConfigurationEvaluationContext): any {
    for(let i = 0, len = this.evaluators.length; i < len; i++) {
      let statementEvaluator = this.evaluators[i];
      let evaluatedValue = statementEvaluator.evaluate(context);
      if(!Check.isNullOrUndefined(evaluatedValue)) {
        return this._applyValueTransformation(context, evaluatedValue);
      }
    }

    return this._applyValueTransformation(context, this.defaultValue);
  }

  private _applyValueTransformation(context: IConfigurationEvaluationContext, value) {
    return context.parsePropertyValue(value).evaluate(context)
  }
}
